var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78335 4.16668C5.78313 4.6087 5.60732 5.03254 5.2946 5.34494C4.98188 5.65735 4.55787 5.83273 4.11585 5.83251C3.67382 5.83229 3.24998 5.65648 2.93758 5.34377C2.62517 5.03105 2.44979 4.60704 2.45001 4.16501C2.45023 3.72298 2.62604 3.29915 2.93876 2.98674C3.25147 2.67434 3.67548 2.49896 4.11751 2.49918C4.55954 2.4994 4.98338 2.6752 5.29578 2.98792C5.60818 3.30064 5.78357 3.72465 5.78335 4.16668V4.16668ZM5.83335 7.06668H2.50001V17.5H5.83335V7.06668ZM11.1 7.06668H7.78335V17.5H11.0667V12.025C11.0667 8.97501 15.0417 8.69168 15.0417 12.025V17.5H18.3333V10.8917C18.3333 5.75001 12.45 5.94168 11.0667 8.46668L11.1 7.06668V7.06668Z",
    fill: "#7C5AC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3595e90f436be72fb858e5f77c611548.svg";
export { ForwardRef as ReactComponent };